//DiaryList.js - 옵션 1
export const sortOptionList = [
  {
    value: "latest",
    name: "최신순",
  },
  {
    value: "oldest",
    name: "오래된 순",
  },
];

//DiaryList.js - 옵션 2
export const filterOptionList = [
  {
    value: "all",
    name: "전체",
  },
  {
    value: "good",
    name: "좋은 감정만",
  },
  {
    value: "bad",
    name: "안 좋은 감정만",
  },
];
